import { matchPath } from 'react-router-dom';

import { Params } from '@remix-run/router/utils';

export const getUrlParamsFromPattern = <T extends { [K in keyof T]?: string }>(
  pathTemplate: string,
  pathName: string,
): Params => {
  const pattern = `(.*)?${pathTemplate}`;
  const match = matchPath(pattern, pathName);
  if (!match) {
    return {};
  }
  return match.params;
};
